import React from 'react';
import { string, func, arrayOf, shape, bool } from 'prop-types';
import styled, { css } from 'styled-components';
import theme from '@airasia-common/libraries/theming/theme';
import Tooltip from '../Tooltip';
import Text from '../Text/Text';
import Row from '../Container/Row';

const activeBtnStyle = css`
  border: 1px solid
    ${({ theme, move }) =>
      move ? theme.colors.secondaryMove : theme.colors.greyLight};
  background: ${({ theme, move }) =>
    move ? theme.colors.secondaryMove : theme.colors.secondary};
  color: ${theme.colors.primaryWhite};
`;

const OptionLabel = styled(Text)`
  width: 185px;
  padding-left: 10px;
  padding-right: 10px;
  height: 42px;
  margin-bottom: 20px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  ${({ active }) => active && activeBtnStyle}
  border-radius: 8px;
  cursor: pointer;
`;

OptionLabel.defaultProps = {
  margin: '4px',
  fontSize: '14px',
  fontWeight: 400,
  color: 'darkBlack',
  border: '1px solid',
  borderColor: 'greyLight',
};

const StyledRow = styled(Row)`
  margin-left: 4px;
`;

const SortByV2 = ({
  selectedId,
  onChange,
  options,
  hoverTranslate,
  enableSortByV2,
  isMoveEnabled,
}) => {
  const RecommendedText = 'recommended';
  return (
    <StyledRow>
      {options.map(item =>
        RecommendedText === item.id &&
        selectedId === RecommendedText &&
        enableSortByV2 ? (
          <Tooltip content={hoverTranslate}>
            <OptionLabel
              className="guest-rating-options"
              active={item.id === selectedId.toString()}
              key={item.id}
              onClick={() => {
                onChange(item);
              }}
              move={isMoveEnabled}
            >
              {item.text}
            </OptionLabel>
          </Tooltip>
        ) : (
          <OptionLabel
            className="guest-rating-options"
            active={item.id === selectedId.toString()}
            key={item.id}
            onClick={() => {
              onChange(item);
            }}
            move={isMoveEnabled}
          >
            {item.text}
          </OptionLabel>
        )
      )}
    </StyledRow>
  );
};

SortByV2.propTypes = {
  onChange: func,
  selectedId: string,
  hoverTranslate: string,
  enableSortByV2: bool,
  options: arrayOf(
    shape({
      id: string,
      text: string,
    })
  ),
  isMoveEnabled: bool,
};

SortByV2.defaultProps = {
  onChange: () => {},
  selectedId: '',
  options: [],
  hoverTranslate: '',
  enableSortByV2: false,
  isMoveEnabled: false,
};

export default SortByV2;
